import {StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (docs/DARK-MODE.md). The web scrim maps to
// overlayLight (accepted one-shade change from the legacy rgba(0, 0, 0, 0.2)
// literal — wave-3 scrim consolidation).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    headerComponent: {
      marginHorizontal: 24,
      backgroundColor: colors.background,
      paddingVertical: 30,
    },
    whiteBackground: {
      backgroundColor: colors.background,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginBottom: 8,
      marginHorizontal: 24,
      marginTop: 16,
    },
    leftButton: {
      flex: 1,
    },
    rightButton: {
      flex: 1,
      marginLeft: 16,
    },
    paddingHorizontal24: {
      paddingHorizontal: 24,
    },
    filterContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    itemContainer: index => ({
      width: index % 2 == 0 ? '40%' : '60%',
      marginTop: 16,
    }),
    title: {
      color: colors.textMuted,
      fontSize: 18,
    },
    checkbox: {
      width: 17,
      height: 17,
    },
    modalContianer: {
      backgroundColor: colors.overlayLight,
      ...CommonStyles.full_flex,
    },
    mainContainer: {
      minWidth: 270,
      width: '30%',
      ...CommonStyles.full_height,
      backgroundColor: colors.surfaceElevated,
      ...CommonStyles.self_end,
    },
  });

export default makeStyles;
